import { useState } from 'react'
import { useSiteData } from '../context/DataContext.jsx'
import RailBlock from '../components/RailBlock.jsx'
import Chip from '../components/Chip.jsx'
import AboutSiteTrigger from '../components/AboutSiteTrigger.jsx'
import ErrorFallback from '../components/ErrorFallback.jsx'
import Skeleton from '../components/Skeleton.jsx'

const YEARS = ['All', '2026', '2024', '2023','2022', '2021']

function ProjectsPage() {
  const { data: siteData, loading, error, refetch } = useSiteData()
  const data = siteData?.projects || []
  const [yearFilter, setYearFilter] = useState('All')

  if (loading) {
    return (
      <div className="pg-layout">
        <div>
          <Skeleton className="h-4 w-32 mb-3" />
          <Skeleton className="h-14 w-56 mb-3" />
          <Skeleton className="h-5 w-80 mb-10" />
          {[1, 2].map((i) => (
            <div key={i} className="border-t border-soft-rule py-7">
              <div className="grid grid-cols-1 sm:grid-cols-[90px_1fr_180px] gap-4 sm:gap-8">
                <Skeleton className="h-3 w-10" />
                <div className="space-y-2">
                  <Skeleton className="h-6 w-56" />
                  <Skeleton className="h-3 w-full max-w-[620px]" />
                </div>
                <Skeleton className="h-3 w-32 justify-self-end" />
              </div>
            </div>
          ))}
        </div>
        <div className="space-y-4">
          <Skeleton className="h-40 w-full" />
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-32 w-full" />
        </div>
      </div>
    )
  }

  if (error) return <ErrorFallback message="Failed to load projects" onRetry={refetch} />

  const projects = data || []
  const filtered = yearFilter === 'All'
    ? projects
    : projects.filter((p) => String(p.year) === yearFilter)

  return (
    <div className="pg-layout">
      {/* LEFT */}
      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.6px] text-soft-faint mb-3">
          Projects · five things
        </p>
        <h1 className="text-[36px] sm:text-[48px] md:text-[56px] font-normal leading-[1.02] tracking-[-1.8px] mb-3">
          Selected work.
        </h1>
        <p className="text-[18px] leading-[1.5] text-soft-dim mb-10">
          Project done most years apart. Listed newest first.
        </p>

        <div>
          {filtered.map((project, index) => (
            <div
              key={project.id}
              className={`grid grid-cols-[90px_1fr_180px] gap-8 py-7 ${
                index > 0 ? 'border-t border-soft-rule' : 'border-t border-soft-rule'
              }`}
            >
              <span className="font-mono text-[12px] text-soft-dim">
                {project.year
                  ? <>
                      {project.year}
                      {project.before_llms && (
                        <span className="block font-mono text-[9px] uppercase tracking-[0.4px] text-soft-faint mt-0.5">
                          pre‑llm-era
                        </span>
                      )}
                    </>
                  : ''}
              </span>
              <div>
                <h2 className="text-[22px] font-medium leading-[1.2] tracking-[-0.4px] text-soft-ink mb-2">
                  {project.title}
                </h2>
                <p
                  className="text-[15px] leading-[1.55] text-soft-dim max-w-[620px]"
                  dangerouslySetInnerHTML={{ __html: project.description }}
                />
              </div>
              <div className="text-right">
                <p className="font-mono text-[12px] text-soft-faint">
                  {project.tech_tags?.join(' · ')}
                </p>
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <p className="text-[17px] text-soft-dim py-8">Nothing matches yet.</p>
          )}
        </div>
      </div>

      {/* RIGHT rail */}
      <aside>
        <RailBlock eyebrow="Filter by year" top>
          <div className="flex flex-wrap gap-2">
            {YEARS.map((y) => (
              <Chip key={y} active={yearFilter === y} onClick={() => setYearFilter(y)}>
                {y}
              </Chip>
            ))}
          </div>
        </RailBlock>

        <RailBlock eyebrow="Most proud of">
          <div className="bg-soft-surface border border-soft-rule p-5">
            <p className="text-[15px] font-medium text-soft-ink mb-1">Educational AI Assistant</p>
            <p className="text-[13.5px] text-soft-dim leading-[1.4]">RAG architecture with opensearch database for contextual question answering.</p>
          </div>
        </RailBlock>

        <AboutSiteTrigger />

        {/*<RailBlock eyebrow="Live on GitHub">*/}
        {/*  <p className="text-[13.5px] text-soft-ink mb-1">12 public repositories</p>*/}
        {/*  <p className="font-mono text-[11px] text-soft-faint">Last commit: 2 days ago</p>*/}
        {/*</RailBlock>*/}
      </aside>
    </div>
  )
}

export default ProjectsPage
